module.exports = __webpack_public_path__ + "img/OperationGuide.949bca3e.png";